import { FC, ReactNode, useEffect, useState, useMemo, } from 'react';
import { ProForm, ProInput, ProSelect } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { getInputPlaceholder, getSelectPlaceholder } from '../utils/ruleUtils';
import { FormItemProps } from 'antd/lib/form';
import { InputProps } from 'antd/lib/input';
import { SelectProps } from 'antd/lib/select';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormInputSelectProps extends BaseSearchFormItemProps {
  /** select Props */
  selectProps?: SelectProps<any>;
  /** input Props */
  inputProps?: InputProps;
  /** 下拉表单配置 */
  afterFormItemProps?: FormItemProps;
  /** 枚举名称 */
  enumCode?: string;
}
/** 输入框+下拉框 */
export const SearchFormInputSelect: FC<SearchFormInputSelectProps> = props => {
  const {
    inputProps,
    selectProps,
    afterFormItemProps,
    isDetail,
    form,
    isTable,
    testId,
    label,
    rules,
    hideLabel,
    enumCode,
    required,
    render,
    disabledRender,
    ...resProps
  } = props;
  const { enumData } = useLayoutContext();
  let afterSelector = null;
  const [beforeNode, setBeforeNode] = useState<ReactNode>(null);
  const inputName: string = resProps.name as string;
  const selectName: string = afterFormItemProps
    ? (afterFormItemProps.name as string)
    : '';
  const options: any[] = useMemo(() => {
    if (selectProps?.options) return selectProps?.options;
    if (enumCode && enumData) {
      return enumData[enumCode] ? enumData[enumCode].items || [] : [];
    }
    return [];
  }, [selectProps?.options, enumData]);
  const normFile = (e: any) => {
    return e?.target?.value?.trim();
  };
  useEffect(() => {
    if (form) {
      let selectValue = form.getFieldValue(selectName);
      if (selectValue && selectProps && options.length) {
        const findOption = options.find(
          v => v.value === selectValue,
        );
        if (findOption && findOption.unit) {
          setBeforeNode(<span>{findOption.unit}</span>);
        }
      }
      if (selectValue === undefined && selectProps && options.length) {
        const findOption = options.find(v => !v.disabled);
        if (findOption) {
          form.setFieldsValue({ [selectName]: findOption.value });
          if (findOption.unit) setBeforeNode(<span>{findOption.unit}</span>);
        }
      }
    }
  }, []);
  const handleSelect = (val: any, option: any) => {
    if (option.unit) {
      setBeforeNode(<span>{option.unit}</span>);
    }
  };
  if (selectProps) {
    afterSelector = (
      <ProForm.Item noStyle {...afterFormItemProps}>
        <ProSelect
          onSelect={handleSelect}
          {...selectProps}
          options={options}
          placeholder={getSelectPlaceholder(label, selectProps, rules)}
          test-id={`${testId}-${afterFormItemProps?.name}`}
        />
      </ProForm.Item>
    );
  }
  return (
    <SearchFormItem
      {...resProps}
      rules={rules}
      label={!hideLabel && label}
      getValueFromEvent={normFile}
    >
      {isDetail || (inputProps && inputProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          names={[
            { name: inputName },
            { name: selectName, options: options },
          ]}
          render={render || disabledRender}
          splitSymbol=""
          isTable={isTable}
        />
      ) : (
        <ProInput
          className="yb-input-select"
          addonBefore={beforeNode}
          addonAfter={afterSelector}
          test-id={`${testId}-${inputName}`}
          {...inputProps}
          placeholder={getInputPlaceholder(`${label}值`, inputProps, rules)}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormInputSelect.displayName = SearchFormItemEnum.SearchFormInputSelect;

export default SearchFormInputSelect;
